import DocusaurusFooter from '../DocusaurusFooter'
import { Paragraph } from '@eggplant/pattern-library'
import { testConfig } from '../../docs-routes'

const TestConfigs = () =>
  <Paragraph>
    Test Configs are combinations of test cases and exploratory tests grouped in specific sequences to run against systems under test (SUTs).
    <DocusaurusFooter path={testConfig} />
  </Paragraph>

export default TestConfigs
